var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"logo-fb",attrs:{"src":_vm.facebookLogoSrc,"alt":"Facebook"},on:{"click":_vm.goToFacebook}}),_c('img',{staticClass:"logo-insta",attrs:{"src":_vm.instagramLogoSrc,"alt":"Instagram"},on:{"click":_vm.goToInstagram}})])
}
var staticRenderFns = []

export { render, staticRenderFns }